import React, { useEffect, useMemo, useState } from 'react'
import "./styles.css";
import { ReactTable } from '../../Components/Molecules';
import { Breadcrumb, Title } from '../../Components/Atoms';
import { Button, Spinner, useToast } from '@chakra-ui/react';
import { DownloadIcon } from '../../Assets/images/svgs';
import { OPERATION_SUMMARY_HEADERS } from '../../Library/tableHeaders';
import { fetchBulkOperationSummary } from '../../APIs';
import { BULK_OPR_STATUS_TYPES, BULK_OPR_STATUS_VALS } from '../../Library/constants';
import { formatTimestamp, getLocalisedDate } from '../../Library/datetime';
import { jsonToCSVConvertor } from '../../Library/jsonUtils';
import PATHS from "../../Routes/paths";

const BulkOperationSummary = () => {
  const Toast = useToast();
  const [operationSummary, setOperationSummary] = useState({});
  const [showLoading, setShowLoading] = useState(false);

  const breadcrumbPaths = [
    { idx: 1, name: "Bulk Operations", link: PATHS.BULK_OPERATIONS },
    { idx: 2, name: "View Summary", isCurrentPage: true },
  ];

  const summaryConfig = [
    { idx: 1, label: "Total Vehicles", key: "count", className: "tv" },
    { idx: 2, label: operationSummary.oprType === 1 ? "Vehicles Immobilised" : "Vehicles Mobilised", key: "vi", className: "vm" },
    { idx: 3, label: "Operation Pending", key: "op", className: "op" },
  ];

  const columns = useMemo(() => {
    const cols = [];
    Object.values(OPERATION_SUMMARY_HEADERS).forEach((header) => {
      cols.push({
        Header: header.nm,
        accessor: header.key,
        disableSortBy: !header.sorting,
        disableFilters: !header.showSearch,
        Cell: ({ row, value, column }) => {
          if (column.id === "srNo") return <span>{row.index < 9 ? 0 : ""}{row.index + 1}</span>;
          return value;
        }
      });
    });

    return cols;
  }, []);

  const getOperationSummary = () => {
    const searchParamas = new URLSearchParams(window.location.search);
    const oprId = searchParamas.get("oprId");
    if (!oprId) return;
    setShowLoading(true);
    fetchBulkOperationSummary(oprId, (err, data) => {
      if (err) {
        console.error(err);
        Toast({ isClosable: true, description: err, position: "bottom", variant: "subtle", duration: 3000 });
      } else {
        if (data && data.length && data[0]) {
          let vehsImmobilized = 0, operationPending = 0;
          data[0].vehDetails.forEach((veh, index) => {
            if (veh.status === BULK_OPR_STATUS_VALS.DONE || veh.status === BULK_OPR_STATUS_VALS.ALREADY_IMMOBILISED) vehsImmobilized++;
            else operationPending++;
            veh.srNo = index + 1;
            veh.status =  BULK_OPR_STATUS_TYPES[veh.status]
            if (veh.ts) {
              veh.date = getLocalisedDate(veh.ts);
              veh.time = formatTimestamp(veh.ts);
              veh.ts = `${getLocalisedDate(veh.ts)} ${formatTimestamp(veh.ts)}`;
            }
          });
          data[0].vi = vehsImmobilized;
          data[0].op = operationPending;
        }
        setOperationSummary(data && data.length ? data[0] : {});
      }
      setShowLoading(false);
    });
  }

  useEffect(() => {
    getOperationSummary();
  }, []);

  const downloadData = () => {
    if(!operationSummary || !operationSummary.vehDetails || !operationSummary.vehDetails.length) return;
    var sendToExcel = operationSummary.vehDetails.map(a => Object.assign({}, a));
    sendToExcel.forEach((veh, idx) => {
      veh["Sr No"] = idx + 1;
      veh["Vehicles"] = veh.reg;
      veh["Status"] = veh.status;
      veh["Date"] = veh.date;
      veh["Time"] = veh.time;
    });

    var sendData = sendToExcel.map(function (exceldata) {
      var args = "Sr No, Vehicles, Status, Date, Time";
      var filteredData = args.split(",").reduce((mem, arg) => {
        arg = arg.trim();
        mem[arg] = exceldata[arg];
        return mem;
      }, {});
      return filteredData;
    });
    if (sendData.length) jsonToCSVConvertor(sendData, "", true, `${operationSummary.oprNm ? operationSummary.oprNm : "Operation_summary"}_` + Date.now(), false);
  }

  return (
    <div className='panel-main bulk-ot-sum'>
      <div className='bc-cnt'>
        <Breadcrumb paths={breadcrumbPaths} />
      </div>
      {showLoading ? <div className="opr-sum-loader">
        <Spinner />
      </div> : <div className='summary-cnt'>
        <div className="title-cnt">
          <Title>{operationSummary.oprNm} {operationSummary.ts ? <span className='title-dtcnt'>({getLocalisedDate(operationSummary.ts)}, {formatTimestamp(operationSummary.ts)})</span> : null}</Title>
          <Button className='sum-dwl-btn' onClick={downloadData}><DownloadIcon />Download</Button>
        </div>
        <div className='stat-cnts'>
          {
            summaryConfig.map((conf) => (
              <div className='stat-cnt' key={conf.idx}>
                <span className={`stat-val ${conf.className}`}>{operationSummary[conf.key] || "0"}</span>
                <span className='stat-key'>{conf.label}</span>
              </div>
            ))
          }
        </div>
        <ReactTable
          data={operationSummary.vehDetails || []}
          columns={columns}
          showSearch={true}
          pageSize={10}
        />
      </div>}
    </div>
  )
}

export default BulkOperationSummary;